import { render, staticRenderFns } from "./ShipperCutoffGroup.vue?vue&type=template&id=9462c9a2"
import script from "./ShipperCutoffGroup.vue?vue&type=script&lang=js"
export * from "./ShipperCutoffGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports